import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';
import { shortUserFragment } from '~/shared/graphql-queries/users';

export default gql`
  fragment FavoriteTopicFragment on FavoriteTopic {
    _id
    type
    entity {
      ...PostFragment
    }
    creator {
      ...ShortUserFragment
    }
    createdAt
  }
  ${postFragment}
  ${shortUserFragment}
`;
